<template>
  <transition name="fade">
    <div class="botao-rolagem">
      <keep-alive>
        <component v-bind:is="showComponentHeader" />
      </keep-alive>
      <button class="notificacao" @click="showFavoritos(true)">
        <SvgIcon
          name="icone_favoritos"
          fill="#ffffff"
          view-box="0 0 50 48"
          height="22"
          width="auto"
        />
      </button>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Favoritos from '@/components/Favoritos.vue';
import SvgIcon from '@/components/ui/SvgIcon';

export default {
  name: 'BotaoFavoritos',
  components: {
    Favoritos,
    SvgIcon,
  },
  computed: {
    ...mapGetters({
      showComponentHeader: 'favoritos/showComponentHeader',
    }),
  },
  methods: {
    ...mapActions({
      showFavoritos: 'favoritos/showFavoritos',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.botao-rolagem {
  position: relative;
  margin-bottom: 5px;

  > button {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  & .dot {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 12px;
    height: 12px;
    border-radius: 20px;
    background: #f44336;
  }

  & .pulse {
    animation: pulse 3s linear infinite;
  }

  & .notificacao {
    display: flex;
    flex-direction: center;
    justify-content: center;
    @extend %nao-selecionavel;
    font-family: 'OpenSans';
    background-color: $cor_roxo;
    color: $cor_roxo;
    font-size: 15px;
    width: 40px;
    height: 40px;
    line-height: 0px;
    border-radius: 100px;
    border: 0px;
    text-align: center;
    outline: none;
    transition: all 0.2s linear;
    cursor: pointer;
    z-index: 200;
    padding: 0px;
    padding-bottom: 0px !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);

    & img {
      align-self: center;
      width: 20px;
      height: 20px;
    }

    &:hover {
      transform: scale(1.2);
    }
    &:focus {
      animation: grow 0.25s linear;
    }
  }

  & .mover {
    bottom: 130px;
  }
}
@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  40% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .botao-rolagem {
    & .notificacao {
      font-size: 15px;
      width: 40px;
      height: 40px;
      bottom: 65px;
      right: 10px;
      padding-bottom: 0;

      &:hover {
        transform: none;
      }
    }
    & .mover {
      bottom: 110px;
    }

    & .dot {
      top: -0.2vh;
      right: -0.4vh;
    }
  }
}
/**
  Transition
 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
